import { render, staticRenderFns } from "./setupsTabs.vue?vue&type=template&id=3aabb45b"
import script from "./setupsTabs.vue?vue&type=script&lang=js"
export * from "./setupsTabs.vue?vue&type=script&lang=js"
import style0 from "./setupsTabs.vue?vue&type=style&index=0&id=3aabb45b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports